<ng-container>
    <div class="footer-wrapper">
        <ul class="footer-delay list-unstyled list-inline" *ngIf="!showBaoying"
            [@fadeInFooter]="showFooter? 'shown': 'hidden'">
            <li *ngIf="showFdaDisclaimer || showLegalDisclaimer" class="full-width">
                <span *ngIf="showFdaDisclaimer" translate="cart.footer.fda.disclaimer"></span>
                <span *ngIf="showLegalDisclaimer" translate="cart.footer.legal.disclaimer"></span>
            </li>
            <li translate="cart.footer.copyright"></li>
            <li>
                <a href="/dotCom/about/terms" translate="cart.footer.terms.and.conditions" target="_blank"
                   *ngIf="showTermsAndConditions"></a>
            </li>
            <li *ngIf="showJpFooterLink">
                <a href="/pwp/files/01132015_JapanLegalPage.pdf" translate="cart.jp.legal.footer"
                   target="_blank"></a><br>
            </li>
            <li>
                <a href="/dotCom/about/dmca" translate="cart.footer.dmca.notice" target="_blank" *ngIf="showDmca"></a>
            </li>
            <li *ngIf="privacyPolicyUrl">
                <a [href]="privacyPolicyUrl" translate="cart.privacy.policy.title" target="_blank"></a>
            </li>
            <li *ngIf="!!recaptchaMobileFooterMessage" class="recaptcha-footer" [innerHTML]="recaptchaMobileFooterMessage | safeHtml"></li>
        </ul>
        <ul class="footer-delay list-unstyled list-inline" *ngIf="showBaoying"
            [@fadeInFooter]="showFooter? 'shown': 'hidden'">
            <li>
                <img src="logo/IDCicon.png" alt=""><span translate="cart.footer.baoying.line.1" target="_blank"></span>
            </li>
            <li>
                <span translate="cart.footer.baoying.line.2"></span>
            </li>
            <li>
                <span translate="cart.footer.baoying.line.3"></span>
            </li>
        </ul>
    </div>
</ng-container>
